import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InvoiceTaxDocumentService } from 'src/app/services/invoice-tax-document.service';

@Component({
  selector: 'app-invoice-tax-webhook-log-dialog',
  templateUrl: './invoice-tax-webhook-log-dialog.component.html',
  styleUrls: ['./invoice-tax-webhook-log-dialog.component.scss'],
})
export class InvoiceTaxWebhookLogDialogComponent implements OnInit {
  loading = true;
  errorMessage: string | null = null;
  /** Objeto retornado pela API (conteúdo do JSON do webhook). */
  payload: any = null;
  /** JSON formatado para leitura rápida. */
  formattedJson = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private invoiceTaxDocumentService: InvoiceTaxDocumentService
  ) {}

  ngOnInit(): void {
    const nfeId = this.config.data?.nfeId as string | undefined;
    if (!nfeId) {
      this.loading = false;
      this.errorMessage = 'Identificador da NF-e (nfeId) não informado.';
      return;
    }
    this.invoiceTaxDocumentService.getWebhookCallbackLog(nfeId).subscribe({
      next: (data) => {
        this.payload = data;
        try {
          this.formattedJson = JSON.stringify(data, null, 2);
        } catch {
          this.formattedJson = String(data);
        }
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        const ex = err?.error?.data?.exception;
        this.errorMessage =
          (typeof ex?.message === 'string' && ex.message) ||
          err?.error?.message ||
          err?.message ||
          'Não foi possível carregar o log do webhook.';
      },
    });
  }

  close(): void {
    this.ref.close();
  }

  /** Aceita string ISO, array estilo Jackson ou Date. */
  formatLogDatetime(value: unknown): string {
    if (value == null) {
      return '—';
    }
    if (value instanceof Date) {
      return value.toLocaleString('pt-BR');
    }
    if (typeof value === 'string') {
      const d = new Date(value);
      return isNaN(d.getTime()) ? value : d.toLocaleString('pt-BR');
    }
    if (Array.isArray(value) && value.length >= 6) {
      const y = value[0];
      const mo = value[1];
      const day = value[2];
      const h = value[3];
      const mi = value[4];
      const s = value[5];
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(day)}/${pad(mo)}/${y} ${pad(h)}:${pad(mi)}:${pad(s)}`;
    }
    return String(value);
  }
}
